import { useTranslation } from 'react-i18next'

import { PageHeader } from '@/components/ui/PageHeader'
import { UploadsTab } from '@/pages/Warehouse/UploadsTab/UploadsTab'

export default function UploadsPage() {
  const { t } = useTranslation()

  return (
    <div className="p-5 space-y-5">
      <PageHeader
        title={t('uploads.page_title', 'История загрузок файлов')}
        subtitle={t('uploads.page_subtitle', 'Журнал загруженных отчетов и XLSX документов')}
      />
      <UploadsTab />
    </div>
  )
}
